<template>
    <!-- Left Sidebar -->
    <section>
  <aside id="leftsidebar" class="sidebar">
      <!-- User Info -->
      <div class="user-info">
          <div class="image">
                <!-- <h1>{{inilah}}</h1> -->
              <img src="images/logo konsel.png" width="48" height="48" alt="User" />
              <!-- <img src="./assets/logo.png"> -->
          </div>
          <div class="info-container">
              <div class="name" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{profile.nama}}</div>
              <div class="email">{{profile.nip}}</div>
              <div class="btn-group user-helper-dropdown">
                  <i class="material-icons" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">keyboard_arrow_down</i>
                  <ul class="dropdown-menu pull-right">
                      <li><a href="javascript:void(0);"><i class="material-icons">person</i>Profile</a></li>
                      <li role="seperator" class="divider"></li>
                      <li><a href="javascript:void(0);"><i class="material-icons">group</i>Followers</a></li>
                      <li><a href="javascript:void(0);"><i class="material-icons">shopping_cart</i>Sales</a></li>
                      <li><a href="javascript:void(0);"><i class="material-icons">favorite</i>Likes</a></li>
                      <li role="seperator" class="divider"></li>
                      <li><a href="javascript:void(0);"><i class="material-icons">input</i>Sign Out</a></li>
                  </ul>
              </div>
          </div>
      </div>
      <!-- #User Info -->
      <!-- Menu -->
<!-- ============================================================= MONEV ========================================================== -->
      <div class="menu" v-if="monev">
          <ul class="list">
              <li class="header">NAVIGASI UTAMA</li>

              <li class="active">
                  <router-link to="/monev_home">
                      <i class="material-icons">home</i>
                      <span>Home</span>
                  </router-link>
              </li>
              <li>
                  <router-link to="/monev_instrumen_ks_bendahara">
                      <i class="material-icons">record_voice_over</i>
                      <span>Instrumen KS/Bendahara</span>
                  </router-link>
              </li>
              <li>
                  <router-link to="/monev_instrumen_komite_sekolah">
                      <i class="material-icons">account_box</i>
                      <span>Instrumen Komite Sekolah</span>
                  </router-link>
              </li>
              <li>
                  <router-link to="/monev_instrumen_guru">
                      <i class="material-icons">accessibility</i>
                      <span>Instrumen Guru</span>
                   </router-link>
              </li>

              <li>
                  <a href="javascript:void(0);" class="menu-toggle">
                      <i class="material-icons">assignment</i>
                      <span>Instrumen Verifikasi Dapodik</span>
                  </a>
                  <ul class="ml-menu">
                      <li>
                          <router-link to="/monev_instrumen_verifikasi_dapodik_smk">SMK</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_instrumen_verifikasi_dapodik_sma">SMA</router-link>
                      </li>
                  </ul>
              </li>


              <li>
                  <a href="javascript:void(0);" class="menu-toggle">
                      <i class="material-icons col-green">assignment_turned_in</i>
                      <span>Verifikasi Instrumen Monev</span>
                  </a>
                  <ul class="ml-menu">
                      <li>
                          <router-link to="/monev_ver_instrumen_guru">Instrumen Guru</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_ver_instrumen_komite_sekolah">Instrumen Komite Sekolah</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_ver_instrumen_ks_bendahara">Instrumen KS/Bendahara</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_ver_instrumen_verifikasi_dapodik_sma">Instrumen Ver Dapodik SMA</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_ver_instrumen_verifikasi_dapodik_smk">Instrumen Ver Dapodik SMK</router-link>
                      </li>
                  </ul>
              </li>

              <li>
                  <a href="javascript:void(0);" class="menu-toggle">
                      <i class="material-icons col-deep-orange">assignment_returned</i>
                      <span>Data Master</span>
                  </a>
                  <ul class="ml-menu">
                      <li>
                          <router-link to="/monev_wilayah">Wilayah</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_kabupaten">Kabupaten</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_kecamatan">Kecamatan</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_kel_des">Kelurahan</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_sekolah">Sekolah</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_user">User</router-link>
                      </li>
                  </ul>
              </li>




              <li class="header">LABELS</li>
              <li>
                  <a href="javascript:void(0);">
                      <i class="material-icons col-amber">extension</i>
                      <span>Pengaturan</span>
                  </a>
              </li>
              <li>
                  <a href="javascript:void(0);" class="menu-toggle">
                      <i class="material-icons col-light-blue">print</i>
                      <span>Laporan/Instrumen</span>
                  </a>
                  <ul class="ml-menu">
                      <li>
                          <router-link to="/monev_lap_instrumen_guru">Instrumen Guru</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_lap_instrumen_komite_sekolah">Instrumen Komite Sekolah</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_lap_instrumen_ks_bendahara">Instrumen KS/Bendahara</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_lap_instrumen_verifikasi_dapodik_sma">Instrumen Ver Dapodik SMA</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_lap_instrumen_verifikasi_dapodik_smk">Instrumen Ver Dapodik SMK</router-link>
                      </li>
                  </ul>
              </li>

              <li>
                  <a href="javascript:void(0);" class="menu-toggle">
                      <i class="material-icons col-light-blue">print</i>
                      <span>Laporan/Analisis</span>
                  </a>
                  <ul class="ml-menu">
                      <li>
                          <router-link to="/hasil_monev_bos">Analisis Hasil Monev BOS</router-link>
                      </li>
                      <li>
                          <router-link to="/hasil_monev_dapodik">Analisis Hasil Monev Dapodik</router-link>
                      </li>
                      <li>
                          <router-link to="/hasil_monev_snp">Analisis Hasil Monev SNP</router-link>
                      </li>
                  </ul>
              </li>




              <li>
                  <a href="javascript:void(0);" @click="logout">
                      <i class="material-icons col-red">lock_outline</i>
                      <span>Keluar</span>
                  </a>
              </li>
          </ul>
      </div>
<!-- ============================================================= MONEV ========================================================== -->

<!-- ============================================================= BHUMIE ========================================================== -->
      <div class="menu" v-if="bhumie">
          <ul class="list">
              <li class="header">NAVIGASI UTAMA</li>

              <li class="active">
                  <router-link to="/bhumie">
                      <i class="material-icons">home</i>
                      <span>Home</span>
                  </router-link>
              </li>

              <li>
                  <a href="javascript:void(0);" class="menu-toggle">
                      <i class="material-icons">assignment</i>
                      <span>Pendataan</span>
                  </a>
                  <ul class="ml-menu" >
                    <li>
                        <a href="javascript:void(0);" class="menu-toggle ">
                            <span>Persiapan</span>
                        </a>
                        <ul class="ml-menu">
                            <li><router-link to="/bhumie_copy_data_pendukung_penilaian">Copy Data Pendukung Penilaian</router-link></li>
                            <li><router-link to="/bhumie_pembuatan_ZNT">Pembuatan ZNT</router-link></li>
                            <li><router-link to="/bhumie_pembuatan_nilai_bangunan">Pembuatan Nilai Bangunan</router-link></li>
                            <li><router-link to="/bhumie_pembuatan_dbkb_standard">Pembuatan DBKB Standard</router-link></li>
                            <li><router-link to="/bhumie_pembuatan_dbkb_non_standard">Pembuatan DBKB Non Standard</router-link></li>
                        </ul>
                    </li>

                    <li>
                        <a href="javascript:void(0);" class="menu-toggle ">
                            <span>Objek Pajak</span>
                        </a>
                        <ul class="ml-menu">
                            <li><router-link to="/bhumie_SPOP_LSPOP">SPOP/LSPOP</router-link></li>
                            <li><router-link to="/bhumie_jln_standard">Jln Standard</router-link></li>
                        </ul>
                    </li>

                    <li>
                        <a href="javascript:void(0);" class="menu-toggle ">
                            <span>Laporan</span>
                        </a>
                        <ul class="ml-menu">
                            <li><router-link to="/bhumie_data_referensi">Data Referensi</router-link></li>
                            <li><router-link to="/bhumie_sk_kepala_daerah">SK Kepala Daerah</router-link></li>
                            <li><router-link to="/bhumie_dhr">DHR</router-link></li>
                        </ul>
                    </li>

                    <li>
                        <a href="javascript:void(0);" class="menu-toggle ">
                            <span>Sistep</span>
                        </a>
                        <ul class="ml-menu">
                            <li><router-link to="/bhumie_hapus_data_sistem">Hapus Data SISTEM</router-link></li>
                            <li><router-link to="/bhumie_reklas">Reklas</router-link></li>
                        </ul>
                    </li>

                    <li>
                        <router-link to="/bhumie_pemekaran_wilayah"><span>Pemekaran Wilayah</span></router-link>
                    </li>
                </ul>
              </li>

              <li>
                  <a href="javascript:void(0);" class="menu-toggle">
                      <i class="material-icons">assignment_late</i>
                      <span>Penilaian</span>
                  </a>
                  <ul class="ml-menu">
                      <li><router-link to="/bhumie_proses_penilaian_massal">Proses Penilaian Massal</router-link></li>
                      <li><router-link to="/bhumie_laporan_penilaian">Laporan Penilaian</router-link></li>

                  </ul>
              </li>

              <li>
                  <a href="javascript:void(0);" class="menu-toggle">
                      <i class="material-icons">assignment_turned_in</i>
                      <span>Penetapan</span>
                  </a>
                  <ul class="ml-menu">
                      <li><router-link to="/bhumie_pbb_minimal">PBB Minimal</router-link></li>
                      <li><router-link to="/bhumie_penetapan_pencetakan_massal">Penetapan & Pencetakkan Massal</router-link></li>
                      <li><router-link to="/bhumie_salinan_massal">Salinan Massal</router-link></li>
                      <li><router-link to="/bhumie_penetapan_pencetakan_terseleksi">Penetapan & Pencetakkan Terseleksi</router-link></li>
                      <li><router-link to="/bhumie_tanda_terima_SPPT_STP">Tanda Terima SPPT/STP</router-link></li>
                      <li><router-link to="/bhumie_simulasi_penetapan_massal">Simulasi Penetapan Massal</router-link></li>
                  </ul>
              </li>

              <li>
                  <a href="javascript:void(0);" class="menu-toggle">
                      <i class="material-icons">assignment_return</i>
                      <span>Penagihan</span>
                  </a>
                  <ul class="ml-menu">
                      <li><router-link to="/bhumie_daftar_tunggakan">Daftar Tunggakan</router-link></li>
                      <li><router-link to="/bhumie_pengeluaran_himbauan">Pengeluaran Himbauan</router-link></li>

                  </ul>
              </li>


              <li>
                  <a href="javascript:void(0);" class="menu-toggle">
                      <i class="material-icons">assignment_returned</i>
                      <span>Pembayaran</span>
                  </a>
                  <ul class="ml-menu" >
                    <li>
                        <a href="javascript:void(0);" class="menu-toggle ">
                            <span>Perekaman</span>
                        </a>
                        <ul class="ml-menu">
                            <li><router-link to="/bhumie_perekaman_tunggal">Perekaman Tunggal</router-link></li>
                            <li><router-link to="/bhumie_perekaman_massal">Perekaman Massal</router-link></li>
                        </ul>
                    </li>

                    <li>
                        <a href="javascript:void(0);" class="menu-toggle ">
                            <span>Pembatalan</span>
                        </a>
                        <ul class="ml-menu">
                            <li><router-link to="/bhumie_pembatalan_tunggal">Pembatalan Tunggal</router-link></li>
                        </ul>
                    </li>

                    <li>
                        <router-link to="/bhumie_laporan_pembayaran"><span>Laporan Pembayaran</span></router-link>
                    </li>  

                    <li>
                        <a href="javascript:void(0);" class="menu-toggle ">
                            <span>Surat Keterangan Pembayaran</span>
                        </a>
                        <ul class="ml-menu">
                            <li><router-link to="/bhumie_cetak_tunggal">Cetak Tunggal</router-link></li>
                            <li><router-link to="/bhumie_cetak_massal">Cetak Massal</router-link></li>
                        </ul>
                    </li>

                </ul>
              </li>

              <li>
                  <a href="javascript:void(0);" class="menu-toggle">
                      <i class="material-icons">account_balance_wallet</i>
                      <span>Pelayanan</span>
                  </a>
                  <ul class="ml-menu">
                      <li><router-link to="/bhumie_parameter_keluaran_pelayanan"><span>Parameter Keluaran Pelayanan</span></router-link></li>
                      <li><router-link to="/bhumie_input_permohonan"><span>Input Permohonan</span></router-link></li>
                      <li><router-link to="/bhumie_cetak_tanda_terima"><span>Cetak Tanda Terima</span></router-link></li>
                      <li><router-link to="/bhumie_adm_op_baru_mutasi"><span>Administrasi OP Baru & Mutasi</span></router-link></li>
                      <li>
                        <a href="javascript:void(0);" class="menu-toggle "><span>Pengurangan</span></a>
                        <ul class="ml-menu">
                            <li><router-link to="/bhumie_input_data_pengurangan_pbb">Input Data Pengurangan PBB</router-link></li>
                            <li><router-link to="/bhumie_proses_sk_pengurangan_pbb">Proses SK Pengurangan PBB</router-link></li>
                        </ul>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="menu-toggle "><span>Keberatan</span></a>
                        <ul class="ml-menu">
                            <li><router-link to="/bhumie_input_sk_atas_keberatan_pbb">Input SK Atas Keberatan PBB</router-link></li>
                            <li><router-link to="/bhumie_proses_sk_atas_keberatan_pbb">Proses SK Atas Keberatan PBB</router-link></li>
                        </ul>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="menu-toggle "><span>Pembetulan SPPT</span></a>
                        <ul class="ml-menu">
                            <li><router-link to="/bhumie_input_sk_tunggal_pembetulan">Input SK Tunggal</router-link></li>
                            <li><router-link to="/bhumie_proses_sk_tunggal_pembetulan">Proses SK Tunggal</router-link></li>
                            <li><router-link to="/bhumie_input_sk_kolektif_pembetulan">Input SK Kolektif</router-link></li>
                            <li><router-link to="/bhumie_proses_sk_kolektif_pembetulan">Proses SK Kolektif</router-link></li>
                        </ul>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="menu-toggle "><span>Pembatalan SPPT</span></a>
                        <ul class="ml-menu">
                            <li><router-link to="/bhumie_input_sk_tunggal_pembatalan">Input SK Tunggal</router-link></li>
                            <li><router-link to="/bhumie_proses_sk_tunggal_pembatalan">Proses SK Tunggal</router-link></li>
                            <li><router-link to="/bhumie_input_sk_kolektif_pembatalan">Input SK Kolektif</router-link></li>
                            <li><router-link to="/bhumie_proses_sk_kolektif_pembatalan">Proses SK Kolektif</router-link></li>
                        </ul>
                      </li>
                      <li><router-link to="/bhumie_cetak_file_keluaran"><span>Cetak File Keluaran</span></router-link></li>
                      <li><router-link to="/bhumie_penyerahan_berkas_selesai_wp"><span>Penyerahan Berkas Pelayanan Selesai ke WP</span></router-link></li>
                      <li><router-link to="/bhumie_penundaan_tgl_jatuh_tempo"><span>Penundaan Tgl Jatuh Tempo</span></router-link></li>
                      <li>
                        <a href="javascript:void(0);" class="menu-toggle "><span>Restitusi dan Kompensasi</span></a>
                        <ul class="ml-menu">
                            <li><router-link to="/bhumie_input_surat_pemberitaan">Input Surat Pemberitaan</router-link></li>
                            <li><router-link to="/bhumie_input_restitusi_kompensasi">Input Restitusi/Kompensasi</router-link></li>
                            <li><router-link to="/bhumie_input_surat_pencabutan_SPMKP_pbb">Input Surat Pencabutan SPMKP PBB</router-link></li>
                            <li><router-link to="/bhumie_restitusi_kompensasi">Laporan Restitusi & Kompensasi</router-link></li>
                        </ul>
                      </li>


                  </ul>
              </li>
   
              <li class="header">DATA MASTER</li>
              <li>
                  <a href="javascript:void(0);" class="menu-toggle">
                      <i class="material-icons col-deep-orange">data_usage</i>
                      <span>Master Wilayah</span>
                  </a>
                  <ul class="ml-menu">
                      <li>
                          <router-link to="/monev_wilayah">Wilayah</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_kabupaten">Kabupaten</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_kecamatan">Kecamatan</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_kel_des">Kelurahan</router-link>
                      </li>
                      <li>
                          <router-link to="/kanwil">Wilayah/Pemda</router-link>
                      </li>
                      <li>
                          <router-link to="/instansi">Instansi</router-link>
                      </li>
                      <li>
                          <router-link to="/monev_user">User</router-link>
                      </li>
                  </ul>
              </li>
              <li>
                  <a href="javascript:void(0);" class="menu-toggle">
                      <i class="material-icons col-teal">assignment_ind</i>
                      <span>Admin</span>
                  </a>
                  <ul class="ml-menu">
                      <li>
                          <router-link to="/bhumie_wewenang">Wewenang</router-link>
                      </li>
                      <li>
                          <router-link to="/bhumie_sms">SMS</router-link>
                      </li>
                      <li>
                          <router-link to="/bhumie_backup">Backup</router-link>
                      </li>
                  </ul>
              </li>
              <li>
                  <a href="javascript:void(0);" class="menu-toggle ">
                      <i class="material-icons col-green">find_in_page</i>
                      <span>Lihat</span>
                  </a>
                  <ul class="ml-menu">
                      <li>
                        <a href="javascript:void(0);" class="menu-toggle "><span>Data Objek Pajak</span></a>
                        <ul class="ml-menu">
                            <li><router-link to="/monev_instrumen_verifikasi_dapodik_smk">Daftar SPOP/LSPOP</router-link></li>
                            <li><router-link to="/monev_instrumen_verifikasi_dapodik_smk">Data Ringkas</router-link></li>
                            <li><router-link to="/monev_instrumen_verifikasi_dapodik_smk">Catatan Pembayaran PBB</router-link></li>
                        </ul>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="menu-toggle "><span>Tabel</span></a>
                        <ul class="ml-menu">
                            <li><router-link to="/monev_instrumen_verifikasi_dapodik_smk">ZNT</router-link></li>
                            <li><router-link to="/monev_instrumen_verifikasi_dapodik_smk">Kls Tanah & Kls Bangunan</router-link></li>
                        </ul>
                      </li>
                      <li><router-link to="/monev_instrumen_verifikasi_dapodik_smk"><span>Nomor Pelayanan</span></router-link></li>
                      <li><router-link to="/monev_instrumen_verifikasi_dapodik_smk"><span>NOP Terbesar</span></router-link></li>
                      <li><router-link to="/monev_instrumen_verifikasi_dapodik_smk"><span>Perubahan NOP</span></router-link></li>
                      <li><router-link to="/monev_instrumen_verifikasi_dapodik_smk"><span>Sejarah Obyek Pajak</span></router-link></li>
                      <li>
                        <a href="javascript:void(0);" class="menu-toggle "><span>Informasi SPPT</span></a>
                        <ul class="ml-menu">
                            <li><router-link to="/monev_instrumen_verifikasi_dapodik_smk">Informasi Relasi Obyek Pajak & Subyek Pajak</router-link></li>
                            <li><router-link to="/monev_instrumen_verifikasi_dapodik_smk">Informasi Rinci SPPT</router-link></li>
                            <li><router-link to="/monev_instrumen_verifikasi_dapodik_smk">Informasi Pelayanan STTS</router-link></li>
                        </ul>
                      </li>
                  </ul>
              </li>

              <li>
                  <a href="javascript:void(0);" class="menu-toggle">
                      <i class="material-icons col-light-green">receipt</i>
                      <span>Referensi</span>
                  </a>
                  <ul class="ml-menu">
                      <!-- <li><router-link to="/monev_ver_instrumen_komite_sekolah"> <span>Wilayah</span> </router-link></li> -->
                      <li><router-link to="/bhumie_kepegawaian"> <span>Kepegawaian</span> </router-link></li>
                      <li><router-link to="/bhumie_tempat_pembayaran"> <span>Tempat Pembayaran</span> </router-link></li>
                      <li><router-link to="/bhumie_tempat_pembayaran_SPPT_massal"> <span>Tempat Pembayaran SPPT Massal</span> </router-link></li>
                      <li>
                        <a href="javascript:void(0);" class="menu-toggle "><span>Harga Resource</span></a>
                        <ul class="ml-menu">
                            <li><router-link to="/bhumie_update_harga_resource">Update Harga Resource</router-link></li>
                            <li><router-link to="/bhumie_lap_harga_resource">Laporan Harga Resource</router-link></li>
                        </ul>
                      </li>
                      <li><router-link to="/bhumie_buku_NJOPTK_tarif"> <span>Buku/NOJOPTKP/Tarif</span> </router-link></li>
                      <li><router-link to="/bhumie_umum"> <span>Umum</span> </router-link></li>

                  </ul>
              </li>
              <li>
                  <a href="javascript:void(0);" class="menu-toggle">
                      <i class="material-icons col-lime">assignment_turned_in</i>
                      <span>GIS</span>
                  </a>
                  <ul class="ml-menu">
                      <li><router-link to="/monev_ver_instrumen_komite_sekolah"> <span>Tematik GIS</span> </router-link></li>
                      <li>
                        <a href="javascript:void(0);" class="menu-toggle "><span>Referensi GIS</span></a>
                        <ul class="ml-menu">
                            <li><router-link to="/monev_instrumen_verifikasi_dapodik_smk">Kelas Bangunan</router-link></li>
                            <li><router-link to="/monev_instrumen_verifikasi_dapodik_smk">Kelas Tanah</router-link></li>
                            <li><router-link to="/monev_instrumen_verifikasi_dapodik_smk">ZNT</router-link></li>
                        </ul>
                      </li>
                  </ul>
              </li>
              <li>
                  <a href="javascript:void(0);">
                      <i class="material-icons col-amber">settings</i>
                      <span>Pengaturan</span>
                  </a>
              </li>

              <li>
                  <a href="javascript:void(0);" @click="logout">
                      <i class="material-icons col-red">lock_outline</i>
                      <span>Keluar</span>
                  </a>
              </li>
          </ul>
      </div>
<!-- ============================================================= BHUMIE ========================================================== -->

<!-- ============================================================= OFFICE ========================================================== -->
      <div class="menu" v-if="office">
            <ul class="list">
                <menu_office></menu_office>
                <li>
                    <a href="javascript:void(0);" @click="logout">
                        <i class="material-icons col-red">lock_outline</i>
                        <span>Keluar</span>
                    </a>
                </li>
            </ul>
      </div>
<!-- ============================================================= OFFICE ========================================================== -->

<!-- ============================================================= SIMPEG ========================================================== -->
      <div class="menu" v-if="simpeg">
            <ul class="list">
                <menu_simpeg></menu_simpeg>
                <li>
                    <a href="javascript:void(0);" @click="logout">
                        <i class="material-icons col-red">lock_outline</i>
                        <span>Keluar</span>
                    </a>
                </li>
            </ul>
      </div>
<!-- ============================================================= SIMPEG ========================================================== -->

<!-- ============================================================= PLANING ========================================================== -->
      <div class="menu" v-if="planing">
          <ul class="list">
            <menu_planning></menu_planning>
              <li>
                  <a href="javascript:void(0);" @click="logout">
                      <i class="material-icons col-red">lock_outline</i>
                      <span>Keluar</span>
                  </a>
              </li>
          </ul>
      </div>
<!-- ============================================================= PLANING ========================================================== -->

<!-- ============================================================= SAKIP ========================================================== -->
      <div class="menu" v-if="sakip">
          <ul class="list">
            <menu_sakip></menu_sakip>
              <li>
                  <a href="javascript:void(0);" @click="logout">
                      <i class="material-icons col-red">lock_outline</i>
                      <span>Keluar</span>
                  </a>
              </li>
          </ul>
      </div>
<!-- ============================================================= SAKIP ========================================================== -->

<!-- ============================================================= REGISTRASI ========================================================== -->
      <div class="menu" v-if="registrasi">
          <ul class="list">
            <menu_registrasi></menu_registrasi>
              <li>
                  <a href="javascript:void(0);" @click="logout">
                      <i class="material-icons col-red">lock_outline</i>
                      <span>Keluar</span>
                  </a>
              </li>
          </ul>
      </div>
<!-- ============================================================= REGISTRASI ========================================================== -->

  
      
      
      
      
      
      <!-- #Menu -->
      <!-- Footer -->
      <div class="legal">
          <div class="copyright">
              &copy; 2017 - 2018 <a href="javascript:void(0);">KyoSoft - Material Design</a>.
          </div>
          <div class="version">
              <b>Version: </b> 1.0.0
          </div>
      </div>
      <!-- #Footer -->
  </aside>
  <!-- #END# Left Sidebar -->

</section>

</template>


<script>

    // import "https://code.jquery.com/jquery-2.2.4.js";
    // import Moment from 'moment'

    export default {
        name: 'monev_left_sidebar',
        data () {
            return {
                msg: 'monev_left_sidebar',
                user: "",
                profile : {},
                planing : false,
                monev : false,
                bhumie : false,
                simpeg : false,
                office : false,
                registrasi : false,
                sakip : false,
                inilah : this.$session.get('MENU')

            }
        },
        methods : {
            logout : function(){
                localStorage.removeItem('token');
                localStorage.removeItem('profile');
                localStorage.removeItem('sidemenu');
                this.$router.push('/monev_login');
            },



            check_sidemenu (){
                if(localStorage.sidemenu == 'bhumie'){
                    this.bhumie = true;
                }
                else if(localStorage.sidemenu == 'monev'){
                    this.monev = true;
                }
                if(localStorage.sidemenu == 'simpeg'){
                    this.simpeg = true;
                }
                else if(localStorage.sidemenu == 'office'){
                    this.office = true;
                }
                else if(localStorage.sidemenu == 'planing'){
                    this.planing = true;
                }
                else if(localStorage.sidemenu == 'registrasi'){
                    this.registrasi = true;
                }
                else if(localStorage.sidemenu == 'sakip'){
                    this.sakip = true;
                }
            },

            get_user : function(){
                fetch(URL_APP, {
                    headers: {
                        authorization: "kikensbatara " + localStorage.token
                }
                }).then(res => res.json())
                .then(result => {
                    if (result.user) {
                    this.user = result.user;
                    this.profile = result.user.profile;
                    localStorage.profile = JSON.stringify(result.user);
                    // console.log(localStorage.profile);

                    } else {
                        this.logout();
                    }
                });
            },


        },
        mounted: function(){
            var get_profile = JSON.parse(localStorage.profile);
            this.profile.nama = get_profile.profile.nama;
            this.profile.nip = get_profile.profile.ref_instansi;
            this.check_sidemenu();
            this.$session.set('MENU','adalah')


        },


    }
</script>

